import '../lessons/components/lesson_footer';
import '../lessons/components/lesson_item';
import './index.scss';
import 'components/mjolnir_video_item';
import 'components/summary_suggestions';
import LessonPlayer from 'components/lesson_player';
import LessonPlayerMjolnir from 'components/lesson_player_mjolnir';

(function ($) {
  'use strict';

  const $lessonPage = $('.js-lesson-page');

  LessonPlayer.start($lessonPage);
  LessonPlayerMjolnir.start($lessonPage);

  $(document).ready(() => {
    UserTracker.emit('event', {
      eventName: 'lesson opened',
      data: {
        'lesson type': 'gravada'
      }
    });
  });
})(jQuery);
